import { createSlice } from "@reduxjs/toolkit";


//let currentWorkingDay= calendarConfig.workingDays.filter((item)=>item.day==new Date().getDay());

const calenderSlice = createSlice({
    name: 'calenderSlice',
    initialState: {
        currentGameId: null,
        scheduleData: [],
        players: [],
        resourceData: [],
        courtNo: [],
        game: [],
        currentView: 'Day',
        dayStartTime: null,
        dayEndTime: null,
        weekDayStartTime: null,
        weekDayEndTime: null,
        isUserValidToAccess:false,
        recurrenceRule: null,
        startHour: '00:00',
        endHour: '24:00',
        calenderConfig: null,
        advanceBookingDay:"0",
        pageNumber: 1,
        pageSize:15,
        openRefundPopup:false,
        refundAmount:null,
        reservationId:null,
        refundReason:'REQUESTED_BY_CUSTOMER',
        maxPlayerWarning:''
    },
    reducers: {
        resetCourtData:(state)=>{
            state.resourceData=null
            state.courtNo=null
        },
        setCurrentView: (state, action) => {
            state.currentView = action.payload
        },
        setIsUserValidToAccess: (state, action) => {
            state.isUserValidToAccess = action.payload
        },
        setAdvanceBookingDay: (state, action) => {
            state.advanceBookingDay = action.payload
        },
        setOpenRefundPopup: (state, action) => {
            state.openRefundPopup = action.payload
        },
        setRefundAmount: (state, action) => {
            state.refundAmount = action.payload
        },
        setReservationId: (state, action) => {
            state.reservationId = action.payload
        },
        setRefundReason: (state, action) => {
            state.refundReason = action.payload
        },
        setRecurrenceRule: (state, action) => {
            state.recurrenceRule = action.payload
        },
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload
        },
        // setSelectedItems: (state, action) => {
        //     state.selectedItems = [action.payload]
        // },
        setCurrentGameId: (state, action) => {
            state.currentGameId = action.payload
        },
        setCurrentView: (state, action) => {
            state.currentView = action.payload
        },
        setScheduleData: (state, action) => {
            state.scheduleData = action.payload;
        },
        setSchedule: (state, action) => {
            state.scheduleData.push(action.payload);
        },
        setWeekDayStartTime: (state, action) => {
            state.weekDayStartTime = action.payload
        },
        setWeekDayEndTime: (state, action) => {
            state.weekDayEndTime = action.payload
        },
        setStartHour: (state, action) => {
            state.startHour = action.payload
        },
        setEndHour: (state, action) => {
            state.endHour = action.payload
        },
        setCalenderConfig: (state, action) => {
            state.calenderConfig = action.payload
        },
        updateSchedule: (state, action) => {
            let newSchedule = action.payload;
            const index = state.scheduleData.findIndex(item => item.Id === newSchedule.Id);

            if (index !== -1) {
                // Create a new array with the updated item
                state.scheduleData = [
                    ...state.scheduleData.slice(0, index),
                    {
                        ...state.scheduleData[index],  // Existing item
                        ...newSchedule  // Updated properties
                    },
                    ...state.scheduleData.slice(index + 1)
                ];
            } else {
                // Optionally handle the case where the item to update is not found
                console.error("Item to update not found");
            }
        },
        removeSchedule: (state, action) => {
            state.scheduleData = state.scheduleData.filter((item) => {
                return item.Id !== action.payload;
            });
        },
        setPlayers: (state, action) => {
            state.players = action.payload
        },
        setCourtNo: (state, action) => {
            state.courtNo = action.payload
        },
        setResourceData: (state, action) => {
            state.resourceData = action.payload
        },
        setGame: (state, action) => {
            state.game = action.payload
        },
        setDayStartTime: (state, action) => {
            state.dayStartTime = action.payload
        },
        setDayEndTime: (state, action) => {
            state.dayEndTime = action.payload
        },
        resetCurrentDate: (state, action) => {
            state.dayStartTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
            state.dayEndTime = new Date(new Date().setHours(23, 59, 59, 999)).getTime() + 1,
            state.scheduleData=[]
        },
        setMaxPlayerWarning: (state, action) => {
            state.maxPlayerWarning = action.payload;
        }
    }
})

export const calenderAction = calenderSlice.actions;
export default calenderSlice.reducer;